/* eslint-disable prettier/prettier */
<template>
  <div>
    <header class="inner-banner">
      <div class="container">
        <div class="row">
          <div class="inner-wrapper">
            <div class="col-md-12">
              <!-- Login -->
              <div class="container">
                <div ref="animeEl" class="card card-container">
                  <a href="/">
                    <img
                      @click="handleStorageClear"
                      src="images/logo.png"
                      alt="Logo"
                      class="text-center"
                    />
                  </a>
                  <h2 style="padding: 10px 0 20px; font-size: 19px !important">
                    Athlete Or Parent Registration Form
                  </h2>
                  <a-form
                    id="components-form-demo-normal-login"
                    :form="form"
                    class="login-form"
                    @submit="handleSubmit"
                  >
                    <a-form-item>
                      <a-input
                        v-decorator="[
                          'username',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please input your User Name!'
                              }
                            ]
                          }
                        ]"
                        type="text"
                        placeholder=" User Name"
                      >
                        <a-icon
                          slot="prefix"
                          type="user"
                          style="color: rgba(0,0,0,.25)"
                        />
                      </a-input>
                    </a-form-item>
                    <a-form-item>
                      <a-input
                        v-decorator="[
                          'email',
                          {
                            rules: [
                              {
                                type: 'email',
                                message: 'The input is not valid E-mail!'
                              },
                              {
                                required: true,
                                message: 'Please input your E-mail!'
                              }
                            ]
                          }
                        ]"
                        type="text"
                        placeholder="E-mail"
                      >
                        <a-icon
                          slot="prefix"
                          type="mail"
                          style="color: rgba(0,0,0,.25)"
                        />
                      </a-input>
                    </a-form-item>
                    <a-form-item has-feedback>
                      <a-input
                        v-decorator="[
                          'password',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please input your password!'
                              },
                              {
                                validator: validateToNextPassword
                              }
                            ]
                          }
                        ]"
                        type="password"
                        placeholder="Password"
                      >
                        <a-icon
                          slot="prefix"
                          type="lock"
                          style="color: rgba(0,0,0,.25)"
                        />
                      </a-input>
                    </a-form-item>
                    <a-form-item has-feedback>
                      <a-input
                        v-decorator="[
                          'passwordConfirm',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please confirm your password!'
                              },
                              {
                                validator: compareToFirstPassword
                              }
                            ]
                          }
                        ]"
                        type="password"
                        placeholder="Confirm Password"
                        @blur="handleConfirmBlur"
                      >
                        <a-icon
                          slot="prefix"
                          type="lock"
                          style="color: rgba(0,0,0,.25)"
                        />
                      </a-input>
                    </a-form-item>
                    <a-form-item>
                      <a-button
                        type="primary"
                        html-type="submit"
                        class="login-form-button width-100-rounded"
                        >Register</a-button
                      >
                    </a-form-item>
                  </a-form>
                  <div class="d-flex-column margin-bottom-1">
                    <span class="login-url-text">
                      Already have an account?<a
                        class="color-secondary"
                        @click="handleStorageClear"
                        href="/login"
                      >
                        Click here to Login</a
                      >
                    </span>
                    <span class="login-url-text">
                      Register as Club Coach?<a
                        class="color-secondary"
                        @click="handleStorageClear"
                        href="/club-register"
                      >
                        Click here
                      </a>
                    </span>
                    <span class="login-url-text">
                      Register as College Coach?<a
                        class="color-secondary"
                        @click="handleStorageClear"
                        href="/college-coach-register"
                      >
                        Click here</a
                      >
                    </span>
                  </div>
                  <a href="/" @click="handleStorageClear" class="color-black">
                    Back To Top Notch Athletes</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/animejs@3.2.0/lib/anime.min.js"></script>
<script>
// import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("users");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default {
  components: {},
  data() {
    return {
      anime: null,
      form: this.$form.createForm(this),
      confirmDirty: false,
      hasErrors
    };
  },

  created() {},

  methods: {
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("Two passwords that you enter is inconsistent!");
      } else {
        callback();
      }
    },
    handleLoginClick() {
      this.$router.push("/login");
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && value.length < 8) {
        callback("Password Should Be at least 8 characters long");
      }
      if (value && this.confirmDirty) {
        form.validateFields(["passwordConfirm"], { force: true });
      }
      callback();
    },
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },
    handleStorageClear() {
      localStorage.clear();
    },
    async handleSubmit(e) {
      e.preventDefault();
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          UserRepository.postUsers(values)
            .then(async response => {
              if (response.status == "success") {
                localStorage.setItem(
                  "token",
                  JSON.stringify(response.data.token)
                );
                this.$notification.success({
                  message: "Success",
                  description: `User ${response.data.user.username} Created Successfully!`
                });
              }
              localStorage.clear();
              localStorage.setItem(
                "token",
                JSON.stringify(response.data.token)
              );
              await this.$store.dispatch(
                "userStore/setUser",
                response.data.user
              );
              that.$router.push({ path: `/profile` });
            })
            .catch(error => {
              if (error.response.data.error.code === 11000) {
                this.$notification.error({
                  message: "Please Enter A New Email",
                  description: "Email Already Taken"
                });
              } else
                this.$notification.error({
                  message: "Error",
                  description: error.response.data.message
                });
            });
        }
      });

      // Jackson SimmonsTrevor Chaney
    }
  },

  computed: {},

  watch: {},

  mounted() {
    this.anime = this.$anime({
      targets: this.$refs.animeEl,
      scale: [0, 1],
      opacity: [0, 1],
      easing: "easeInOutSine",
      duration: 2000
    });
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      // this.form.validateFields();
    });
  }
};
</script>
<style scoped lang="sass">
.login-url-text
  align-self: start
  margin-bottom: 8px
  font-size: 15px
  a
    text-decoration: underline
</style>
